import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//

import { isEmpty } from "lodash";
import { extractApplicationRouteName } from "@Shared/@Utils/utils";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ClientActivityAnchor",
  props: {
    accountDetails: {
      type: Object,
      default: () => ({})
    },
    type: {
      type: String,
      default: ""
    },
    metadata: {
      type: Object,
      default: () => ({})
    },
    clientActivityId: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      downloadAnchorPath: "#/"
    };
  },
  computed: {
    sessionAccountType() {
      const {
        accountType
      } = this.$auth.session.get().accountDetails;
      return accountType === "agent" ? "broker" : accountType;
    },
    anchor() {
      const activity = this.anchorParser(_objectSpread(_objectSpread({}, this.accountDetails), this.metadata))[this.type];
      const anchor = activity.href[this.sessionAccountType];
      if (!anchor && !this.accountDetails.applicationId) {
        return "#/clients/applications";
      }
      return anchor;
    },
    invalidAnchor() {
      return isEmpty(this.anchor);
    },
    anchorClass() {
      return this.invalidAnchor ? "text-light-gray" : "clickable text-primary bold";
    },
    requiresDownload() {
      return this.anchor === this.downloadAnchorPath;
    }
  },
  methods: {
    closePopover() {
      //eslint-disable-next-line vue/custom-event-name-casing
      this.$root.$emit("popover:close");
    },
    getBrokerApplicationPageParams(applicationId, clientUsername, agentUsername, tab) {
      const tabParam = extractApplicationRouteName(tab, false);
      return `#/applications/${applicationId}/client/${clientUsername}/agent/${agentUsername}${tabParam ? `/${tabParam}` : ""}`;
    },
    anchorParser({
      applicationId,
      clientUsername,
      docType,
      agentUsername,
      clientProfileId
    }) {
      const parsedDocType = window.encodeURIComponent(docType);
      return {
        "new-client-signup": {
          href: {}
        },
        "document-uploaded": {
          href: {
            client: `#/documents?docType=${parsedDocType}`,
            broker: applicationId ? this.getBrokerApplicationPageParams(applicationId, clientUsername, agentUsername, "documents") : `#/clients/applications?clientUsername=${clientUsername}`
          }
        },
        "requested-documents": {
          href: {
            client: "#/documents",
            broker: applicationId ? this.getBrokerApplicationPageParams(applicationId, clientUsername, agentUsername, "documents") : `#/clients/applications?clientUsername=${clientUsername}`
          }
        },
        "marked-document-complete": {
          href: {
            client: `#/documents?docType=${parsedDocType}`,
            broker: applicationId ? this.getBrokerApplicationPageParams(applicationId, clientUsername, agentUsername, "documents") : `#/clients/applications?clientUsername=${clientUsername}`
          }
        },
        "marked-document-outstanding": {
          href: {
            client: `#/documents?docType=${parsedDocType}`,
            broker: this.getBrokerApplicationPageParams(applicationId, clientUsername, agentUsername, "documents")
          }
        },
        "application-changed": {
          href: {
            client: "#/application",
            broker: applicationId ? this.getBrokerApplicationPageParams(applicationId, clientUsername, agentUsername) : `#/clients/applications?clientUsername=${clientUsername}`
          }
        },
        "application-submitted": {
          href: {
            client: "#/application",
            broker: applicationId ? this.getBrokerApplicationPageParams(applicationId, clientUsername, agentUsername) : `#/clients/applications?clientUsername=${clientUsername}`
          }
        },
        "comment-added-to-document": {
          href: {
            client: `#/documents?docType=${parsedDocType}`,
            broker: applicationId ? this.getBrokerApplicationPageParams(applicationId, clientUsername, agentUsername) : `#/clients/applications?clientUsername=${clientUsername}`
          }
        },
        "reminder-added": {
          href: {
            broker: `#/clients/board/${clientProfileId}`
          }
        },
        "broker-import-completed": {
          href: {
            client: this.downloadAnchorPath,
            broker: this.downloadAnchorPath
          }
        }
      };
    },
    openFile() {
      if (this.requiresDownload) {
        var _this$accountDetails;
        this.$emit("open-file", {
          type: this.type,
          username: (_this$accountDetails = this.accountDetails) == null ? void 0 : _this$accountDetails.agentUsername,
          id: this.clientActivityId
        });
      }
    },
    isEmpty(val) {
      return isEmpty(val);
    }
  }
});